module.exports = __webpack_public_path__ + "assets/3ef5fbf1d61fca6d9f3bad3f8ab2e41a.png";